import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MediaBluetoothOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"media_bluetooth_off"}/>
}
